module.exports = __webpack_public_path__ + "img/cg.7b35ddc8.png";